// extracted by mini-css-extract-plugin
module.exports = {"layout":"FavePaySetupView_layout__1pIcC","steps":"FavePaySetupView_steps__DLWMH"};